//AbtHeroSection

import '../../styles/about/hero.css'; // Don't forget to create this CSS file

const HeroSection = () => {
  return (
    <section className="hero-sectionFaq1">
      {/* 1. The Dark Overlay (Background) */}
      <div className="hero-overlay"></div>

      {/* 2. The Content (Foreground) - High Z-Index ensures this sits ON TOP */}
      <div className="container hero-content">
        <div className="row align-items-center" style={{ height: '100%' }}>
          <div className="col-12 col-md-10 col-lg-8">
            
            {/* Breadcrumb */}
            <div className="mb-3">
              <span className="text-white-50 fw-bold">Home</span>
              <span className="mx-2 text-white-50">|</span>
              <span className="text-white fw-bold">About</span>
            </div>

            {/* Headline */}
            <h1 className="display-4 text-white fw-bold">
              Guiding Students.<br />
              Shaping Professionals.
            </h1>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;